'use client'

import { useEffect } from 'react'
import { isApplePayAvailable } from '@segway/core'
import useBraintreeApplePay, {
  ApplePaymentConfig,
} from '@segway/core/src/businessHooks/useBraintreeApplePay'

import { useRouter } from '@/i18n/navigation'

type ApplePayWidgetProps = {
  totalPrice: number
  parsedPaymentConfig?: ApplePaymentConfig
  pageType: 'checkout'
}

const ApplePayWidget = ({ pageType, totalPrice, parsedPaymentConfig }: ApplePayWidgetProps) => {
  const router = useRouter()

  const { braintreeInstance, handleTotalPriceChange } = useBraintreeApplePay(
    router,
    'braintree_apple_pay',
    totalPrice,
    pageType,
    parsedPaymentConfig,
  )

  useEffect(() => {
    if (totalPrice && braintreeInstance) {
      handleTotalPriceChange(totalPrice?.toString())

      braintreeInstance.updateConfiguration('applePay', 'paymentRequest', {
        total: {
          label: 'Segway',
          amount: totalPrice?.toString(),
        },
        currencyCode: 'USD',
        requiredBillingContactFields: ['postalAddress'],
        requiredShippingContactFields: ['email', 'phone'],
      })
    }
  }, [totalPrice, parsedPaymentConfig, braintreeInstance, handleTotalPriceChange])

  useEffect(() => {
    const styleId = 'apply-pay-styles-' + Math.random().toString(36).substr(2, 9)
    const style = document.createElement('style')
    style.id = styleId
    style.textContent = `
      #braintree_apple_pay .braintree-dropin .braintree-placeholder {
        display: none !important;
      }
      #braintree_apple_pay .braintree-dropin .braintree-upper-container::before {
        border: none !important;
        background-color: transparent;
      }
      #braintree_apple_pay .braintree-dropin .braintree-upper-container .braintree-loader__container {
        border: none !important;
        display: none !important;
      }
      #braintree_apple_pay .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-applyPay {
        border: none !important;
      }
      #braintree_apple_pay .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-applyPay .braintree-sheet__header {
        display: none !important;
        width: 100% !important;
      }
      #braintree_apple_pay .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-googlePay .braintree-sheet__content {
        min-height: 100% !important;
        padding: 0 !important;
      }
    `
    document.head.appendChild(style)

    return () => {
      const styleElement = document.getElementById(styleId)
      if (styleElement) document.head.removeChild(styleElement)
    }
  }, [])

  if (!isApplePayAvailable()) return null

  return <div id="braintree_apple_pay" />
}

export default ApplePayWidget
